import { useCallback } from 'react';
import { useQueue } from '../../api/use-queue';
import { useSimuladorEnergiaSolarState } from '../state';
import { getErrorData } from '../../shared/utils/error';
import { SIMULATION_STEPS } from '../simulation-steps';
import { devLog } from '../../../../utils/browser';

export function useStatusActions() {
  const { token, setSimulationStep, showErrorStep, EventHandler, setProposalId } =
    useSimuladorEnergiaSolarState();

  const handleStatusError = useCallback(
    (error) => {
      const { message, rawMessage, errorData } = getErrorData(error);

      if (`${message}`.startsWith('end-journey')) {
        const variant = message.split(':')[1] || 'proposal-failed';
        setSimulationStep({
          ...SIMULATION_STEPS.END_JOURNEY_FINAL,
          variant,
        });
        return;
      }

      if (`${message}`.startsWith('store-not-found')) {
        setSimulationStep(SIMULATION_STEPS.END_JOURNEY_STORE_NOT_FOUND);
        return;
      }

      if (message === 'not-available') {
        showErrorStep({
          rawMessage,
          errorData,
          title: 'Sem ofertas disponíveis',
          message: 'Não temos uma oferta de simulação disponível para você neste momento.',
          event: 'reset',
          ctx: 'no-simulation-available',
        });
        return;
      }

      showErrorStep({ message, rawMessage, errorData, ctx: 'api-status-error' });
    },
    [setSimulationStep, showErrorStep],
  );

  const handleStatusComplete = async (results) => {
    devLog('Status complete results:', results);

    if (results?.proposalId) {
      setProposalId(results?.proposalId);
    }
    setSimulationStep(SIMULATION_STEPS.FORM_PROPOSAL);
    EventHandler.emit('refetch-best-offer');
  };

  const queueStatus = useQueue({
    token,
    enqueueEndpoint: 'energia-solar-queue/v2/simulation/status',
    onError: handleStatusError,
    onComplete: handleStatusComplete,
    retryLimit: 15,
    timeout: 20000,
  });

  return queueStatus;
}
